export function getBannerCtaCopy({
  discountAmount,
}: {
  discountAmount: number;
}) {
  return discountAmount === 0 ? 'START NOW' : 'REDEEM NOW';
}
